module.exports = __webpack_public_path__ + "img/icb-leo-novice-e@2x.b4a92aa6.png";